import React from "react";
import { IconButton } from "@chakra-ui/react";
import { FaEdit, FaCalendarAlt, FaFutbol, FaTrophy } from "react-icons/fa";
import { ObjectiveData } from "../RegisterObjectiveModal";
import "../Layout/football-details.css";

interface PlayerInfoInterface {
  goal: number;
  victory: number;
  playerId: number;
  edit: (data: ObjectiveData) => void;
  seasonId: number;
  date: string;
  id: number;
  isAdmin?: boolean;
  own_goal: number;
}

export const PlayerEdit: React.FC<PlayerInfoInterface> = ({
  playerId,
  edit,
  seasonId,
  goal,
  victory,
  date,
  id,
  isAdmin = false,
  own_goal,
}) => {
  const data: ObjectiveData = {
    userId: playerId,
    seasonId,
    goal,
    victory,
    date,
    id,
    own_goal,
  };

  const parsedDate = new Date(`${date.slice(0, 10)}T00:00:00`);
  const formattedDate = Number.isNaN(parsedDate.getTime()) ? date : new Intl.DateTimeFormat("pt-BR").format(parsedDate);
  return (
    <article className="match-card">
      <header className="match-card__header">
        <div><span className="football-eyebrow">DESEMPENHO NA PARTIDA</span><h2><FaCalendarAlt aria-hidden="true" />{formattedDate}</h2></div>
        {isAdmin && <IconButton className="squad-action" variant="unstyled" aria-label={`Editar partida de ${formattedDate}`} icon={<FaEdit />} onClick={() => edit(data)} />}
      </header>
      <div className="match-stats">
        <div><FaFutbol aria-hidden="true" /><strong>{goal}</strong><span>Gols</span></div>
        <div><FaTrophy aria-hidden="true" /><strong>{victory}</strong><span>Vitórias</span></div>
        <div className="match-stats__against"><FaFutbol aria-hidden="true" /><strong>{own_goal}</strong><span>Gols contra</span></div>
      </div>
    </article>
  );
};
